// 交易统计 - 简体中文
export default {
  loading: {
    text: "拼命加载中",
  },
  common: {
    showOnGraph: "上图",
    none: "--",
  },
  usdt: {
    name: "USDT",
    first: "首笔USDT：",
  },
  fields: {
    earliestIn: "最早转入",
    latestIn: "最晚转入",
    earliestOut: "最早转出",
    latestOut: "最晚转出",
    inQty: "转入数量",
    outQty: "转出数量",
    inAvgQty: "转入平均数量",
    outAvgQty: "转出平均数量",
    inCount: "转入笔数",
    outCount: "转出笔数",
    inAddressCount: "转入地址数",
    outAddressCount: "转出地址数",
  },
  currency: {
    firstPrefix: "首笔",
  },
  bigAddress: {
    empty: "当前地址交易数据过多，暂时不支持此类数据的查看",
  },
};
